import React, { ReactNode, MouseEvent } from 'react';
import './touchable-opacity.scss';

interface TouchableOpacityProps {
  children?: ReactNode;
  className?: string;
  style?: React.CSSProperties;
  disabled?: boolean;
  onPress?: (event: MouseEvent<HTMLDivElement, globalThis.MouseEvent>) => void;
  onTouchStart?: (event: React.TouchEvent<HTMLDivElement>) => void;
  onTouchEnd?: (event: React.TouchEvent<HTMLDivElement>) => void;
  onTouchCancel?: (event: React.TouchEvent<HTMLDivElement>) => void;
  allowAnimation?: boolean;
  dataAction?: string;
  containerRef?: React.Ref<HTMLDivElement>;
}

export const TouchableOpacity: React.FC<TouchableOpacityProps> = ({
  children,
  className = '',
  style = {},
  disabled = false,
  onPress,
  onTouchStart,
  onTouchEnd,
  onTouchCancel,
  allowAnimation = true,
  dataAction = '',
  containerRef,
}) => {
  // const rippleRef = useRef<HTMLDivElement>(null);
  // const createRipple = (event: MouseEvent<HTMLDivElement>) => {
  //   if (disabled) return;
  //   const container = rippleRef.current;
  //   if (!container) return;
  //   const circle = document.createElement('span');
  //   const diameter =
  //     Math.max(container.clientWidth, container.clientHeight) * 0.6;
  //   const radius = diameter / 2;
  //   circle.style.width = circle.style.height = `${diameter}px`;
  //   circle.style.left = `${event.clientX - container.getBoundingClientRect().left - radius}px`;
  //   circle.style.top = `${event.clientY - container.getBoundingClientRect().top - radius}px`;
  //   circle.className = 'ripple';
  //   const existingRipple = container.getElementsByClassName('ripple')[0];
  //   if (existingRipple) {
  //     existingRipple.remove();
  //   }
  //   container.appendChild(circle);
  // };

  const handleClick = (event: MouseEvent<HTMLDivElement>) => {
    event.preventDefault();
    event.stopPropagation();
    if (disabled) {
      return;
    }
    onPress?.(event);
  };

  return (
    <div
      ref={containerRef}
      className={`touchable-opacity ${className} ${disabled ? 'disabled' : ''}`}
      onClick={handleClick}
      tabIndex={disabled ? -1 : 0}
      style={{
        ...style,
        pointerEvents: disabled ? 'none' : 'auto',
      }}
      onTouchStart={(e) => !disabled && onTouchStart?.(e)}
      onTouchEnd={(e) => !disabled && onTouchEnd?.(e)}
      onTouchCancel={(e) => !disabled && onTouchCancel?.(e)}
      data-action={dataAction}
      aria-disabled={disabled}
    >
      {children}
    </div>
  );
};
